import { Beitragsvariante } from 'rlv-common';
import { TrackingElementFeePage } from '../../../tracking/tracking.types';
import { BenefitProps, RadioTabButtonDataProps, RadioTabContentDataProps } from './RadioTab.types';
import {
  AFTER_INSURANCE_TOOLTIP,
  BASIC_AFTER_INSURANCE_TOOLTIP,
  BENEFITS_FROM_BASIC_AND_KONFORT_TOOLTIP,
  BENEFITS_FROM_BASIC_TOOLTIP,
  BENEFITS_FROM_BASIC_TOOLTIP_GREATER_50,
  BONUS_LIFETIME_TOOLTIP,
  EARLY_DEATH_TOOLTIP,
  HELP_FOR_RELATIVES_TOOLTIP,
  MEDICAL_OPINION_TOOLTIP,
  ORPHAN_PROTECTION_TOOLTIP,
  PAYMENT_NO_PERIOD_TOOLTIP,
  PROVISIONAL_COVER_TOOLTIP,
  SECOND_OPINION_TOOLTIP,
  TEMPORARY_INCREASE_TOOLTIP,
} from './RadoTabTooltips';

export const RadioTabButtonData: RadioTabButtonDataProps[] = [
  {
    variant: Beitragsvariante.BASIS,
    unavailableForSmoker: true,
  },
  {
    variant: Beitragsvariante.KOMFORT,
  },
  {
    variant: Beitragsvariante.PREMIUM,
    highlightText: 'mit Waisenschutz',
  },
];

const basicBenefitData: BenefitProps[] = [
  {
    title: 'Auszahlung der Summe ohne Wartezeit',
    tooltip: PAYMENT_NO_PERIOD_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_PAYMENT_NO_PERIOD,
  },
  {
    title: 'Erhöhung der Summe ohne erneute Gesundheitsprüfung',
    tooltip: BASIC_AFTER_INSURANCE_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_BASIC_AFTER_INSURANCE,
  },
  {
    title: 'Vorgezogene Todesfallleistung bei schwerer Krankheit',
    tooltip: EARLY_DEATH_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_EARLY_DEATH,
  },
];

const basicBenefitDataGreater50: BenefitProps[] = [
  {
    title: 'Auszahlung der Summe ohne Wartezeit',
    tooltip: PAYMENT_NO_PERIOD_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_PAYMENT_NO_PERIOD,
  },
  {
    title: 'Vorläufiger Versicherungsschutz',
    tooltip: PROVISIONAL_COVER_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_PROVISIONAL_COVER,
  },
  {
    title: 'Vorgezogene Todesfallleistung bei schwerer Krankheit',
    tooltip: EARLY_DEATH_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_EARLY_DEATH,
  },
];

const comfortBenefitData: BenefitProps[] = [
  {
    title: 'Alle Leistungen aus dem Grundschutz',
    tooltip: BENEFITS_FROM_BASIC_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_BENEFITS_FROM_BASIC,
  },
  {
    title: 'Erweiterte Erhöhung der Summe ohne erneute Gesundheitsprüfung',
    tooltip: AFTER_INSURANCE_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_AFTER_INSURANCE,
  },
  {
    title: 'Temporäre Erhöhung der Summe',
    tooltip: TEMPORARY_INCREASE_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_TEMPORARY_INCREASE,
  },
  {
    title: 'Soforthilfe für Angehörige',
    tooltip: HELP_FOR_RELATIVES_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_HELP_FOR_RELATIVES,
  },
];

const comfortBenefitDataGreater50: BenefitProps[] = [
  {
    title: 'Alle Leistungen aus dem Grundschutz',
    tooltip: BENEFITS_FROM_BASIC_TOOLTIP_GREATER_50,
    trackingElement: TrackingElementFeePage.INFOICON_BENEFITS_FROM_BASIC,
  },
  {
    title: 'Soforthilfe für Angehörige',
    tooltip: HELP_FOR_RELATIVES_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_HELP_FOR_RELATIVES,
  },
  {
    title: 'Auszahlung der Summe ohne Wartezeit',
    tooltip: PAYMENT_NO_PERIOD_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_PAYMENT_NO_PERIOD,
  },
  {
    title: 'Vorgezogene Todesfallleistung bei schwerer Krankheit',
    tooltip: EARLY_DEATH_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_EARLY_DEATH,
  },
];

const premiumBenefitData: BenefitProps[] = [
  {
    title: 'Inklusive aller Leistungen aus dem Grund- und Komfortschutz',
    tooltip: BENEFITS_FROM_BASIC_AND_KONFORT_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_BENEFITS_FROM_BASIC_AND_KONFORT,
  },
  {
    title: 'Monatlicher Waisenschutz für jedes Kind bis 18 Jahre',
    tooltip: ORPHAN_PROTECTION_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_ORPHAN_PROTECTION,
  },
  {
    title: 'Verlängerung der Laufzeit um 15 Jahre ohne erneute Gesundheitsprüfung',
    tooltip: MEDICAL_OPINION_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_MEDICAL_OPINION,
  },
  {
    title: 'Pflegebonus bis 15.000 € zu Lebzeiten',
    tooltip: BONUS_LIFETIME_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_BONUS_LIFETIME,
  },
  {
    title: 'Kostenlose medizinische Zweitmeinung',
    tooltip: SECOND_OPINION_TOOLTIP,
    trackingElement: TrackingElementFeePage.INFOICON_SECOND_OPINION,
  },
];

export const RadioTabContentData: RadioTabContentDataProps[] = [
  {
    variant: Beitragsvariante.PREMIUM,
    title: ' - maximale Absicherung mit vielen Extras',
    benefitsData: premiumBenefitData,
  },
  {
    variant: Beitragsvariante.KOMFORT,
    title: ' - leistungsstarker Bestseller',
    benefitsData: comfortBenefitData,
  },
  {
    variant: Beitragsvariante.BASIS,
    title: ' – preisgünstige Absicherung',
    benefitsData: basicBenefitData,
  },
];

export const RadioTabContentDataGreater50: RadioTabContentDataProps[] = [
  {
    variant: Beitragsvariante.PREMIUM,
    title: ' - maximale Absicherung mit vielen Extras',
    benefitsData: premiumBenefitData,
  },
  {
    variant: Beitragsvariante.KOMFORT,
    title: ' - leistungsstarker Bestseller',
    benefitsData: comfortBenefitDataGreater50,
  },
  {
    variant: Beitragsvariante.BASIS,
    title: ' – preisgünstige Absicherung',
    benefitsData: basicBenefitDataGreater50,
  },
];
